"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
exports.Status = {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusFinetuning: "STATUS_FINETUNING",
    StatusDeployingApi: "STATUS_DEPLOYING_API",
    StatusReady: "STATUS_READY",
    StatusFailed: "STATUS_FAILED",
    StatusDeleted: "STATUS_DELETED",
    StatusTemporarilyOffline: "STATUS_TEMPORARILY_OFFLINE",
    StatusPaused: "STATUS_PAUSED",
    StatusQueued: "STATUS_QUEUED",
};
